var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5924 7.00024L13.0455 2.54712C13.2569 2.33615 13.3757 2.04986 13.376 1.75124C13.3763 1.45261 13.2579 1.16612 13.0469 0.954774C12.836 0.743429 12.5497 0.624549 12.2511 0.624286C11.9524 0.624022 11.6659 0.742396 11.4546 0.953368L7.00146 5.40649L2.54834 0.953368C2.33699 0.742023 2.05035 0.623291 1.75146 0.623291C1.45258 0.623291 1.16593 0.742023 0.954588 0.953368C0.743244 1.16471 0.624512 1.45136 0.624512 1.75024C0.624512 2.04913 0.743244 2.33577 0.954588 2.54712L5.40771 7.00024L0.954588 11.4534C0.743244 11.6647 0.624512 11.9514 0.624512 12.2502C0.624512 12.5491 0.743244 12.8358 0.954588 13.0471C1.16593 13.2585 1.45258 13.3772 1.75146 13.3772C2.05035 13.3772 2.33699 13.2585 2.54834 13.0471L7.00146 8.59399L11.4546 13.0471C11.6659 13.2585 11.9526 13.3772 12.2515 13.3772C12.5503 13.3772 12.837 13.2585 13.0483 13.0471C13.2597 12.8358 13.3784 12.5491 13.3784 12.2502C13.3784 11.9514 13.2597 11.6647 13.0483 11.4534L8.5924 7.00024Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogCross);
export default __webpack_public_path__ + "static/media/DialogCross.11720fce3fb4bb275aef2437b4acb921.svg";
export { ForwardRef as ReactComponent };